// Translations for the Login page (runs before authentication).
const loginDict = [
  { en: "TAREWU Management System", sw: "Mfumo wa Usimamizi wa TAREWU" },
  { en: "Invalid email or password", sw: "Barua pepe au nenosiri si sahihi" },
  { en: "Email", sw: "Barua pepe" },
  { en: "Enter your email", sw: "Weka barua pepe yako" },
  { en: "Password", sw: "Nenosiri" },
  { en: "Enter your password", sw: "Weka nenosiri lako" },
  { en: "Signing in...", sw: "Inaingia..." },
  { en: "Sign In", sw: "Ingia" },
  { en: "Demo Credentials:", sw: "Taarifa za Kuingia za Majaribio:" },
];

export default loginDict;
